import React from 'react';
import { FadeIn } from './FadeIn';
import { Gift } from 'lucide-react';
export function Bonuses() {
  const bonuses = [{
    emoji: '🎁',
    title: 'Banco de Actividades Express',
    desc: 'Actividades rápidas listas para resolver sesiones sin improvisar.'
  }, {
    emoji: '📋',
    title: 'Plantillas de Seguimiento de Lectoescritura',
    desc: 'Registros simples para observar avances con más claridad.'
  }, {
    emoji: '📝',
    title: 'Informes de Lectoescritura Listos',
    desc: 'Modelos y frases base para redactar informes más rápido.'
  }, {
    emoji: '👨‍👩‍👧',
    title: 'Kit de Comunicación con Familias',
    desc: 'Mensajes y devoluciones claras para acompañar a las familias.'
  }, {
    emoji: '🧭',
    title: 'Secuencias de Intervención Paso a Paso',
    desc: 'Guías prácticas para saber qué trabajar primero según la dificultad.'
  }, {
    emoji: '🎲',
    title: 'Juegos de Refuerzo para Lectoescritura',
    desc: 'Recursos lúdicos para reforzar lectura y escritura de forma dinámica.'
  }];
  return <section className="pt-4 pb-12 px-4 max-w-5xl mx-auto" data-id="element-13">
      <FadeIn className="text-center mb-8" data-id="element-14">
        <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-mint text-black mb-4" data-id="element-15">
          <Gift size={32} data-id="element-16" />
        </div>
        <h2 className="font-display text-3xl md:text-4xl font-bold text-mint mb-3" data-id="element-17">
          6 BONOS ESTRATÉGICOS
        </h2>
        <p className="text-xl font-medium text-mint/70" data-id="element-18">
          (Incluidos sin costo extra · Valor total $98.200)
        </p>
      </FadeIn>

      <div className="flex flex-col gap-3 max-w-3xl mx-auto" data-id="element-19">
        {bonuses.map((bonus, idx) => <FadeIn key={idx} delay={idx * 0.08} className="bg-surface border border-mint/20 rounded-xl p-4 md:p-5 group hover:border-mint/50 transition-colors" data-id="element-20">
            <div className="flex flex-col sm:flex-row sm:items-center gap-3" data-id="element-21">
              <div className="flex items-center gap-3 flex-1 min-w-0" data-id="element-22">
                <span className="shrink-0 inline-flex items-center justify-center w-10 h-10 rounded-lg bg-mint/15 text-lg" data-id="element-23">
                  {bonus.emoji}
                </span>
                <div className="min-w-0" data-id="element-24">
                  <h3 className="font-bold text-white text-base leading-tight" data-id="element-25">
                    {bonus.title}
                  </h3>
                  <p className="text-white/50 text-sm mt-0.5 leading-snug" data-id="element-26">
                    {bonus.desc}
                  </p>
                </div>
              </div>
              <div className="shrink-0 flex items-center gap-2 pl-13 sm:pl-0" data-id="element-27">
                <span className="text-mint font-[800] text-sm font-['Open_Sans',_sans-serif] uppercase" data-id="element-28">
                  Gratis
                </span>
              </div>
            </div>
          </FadeIn>)}
      </div>
    </section>;
}